import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:9016/api'

export const getAuditSummaryIssueReport = (pageNum, pageSize) => {
  const url = `${API_ROOT}/v1/audit/ia/report/page?pageNum=${pageNum || 0}&pageSize=${
    pageSize || 0
  }`
  return doGet(url)
}

export const searchAuditSummaryIssueReport = (request, pageNum, pageSize) => {
  const url = `${API_ROOT}/v1/audit/ia/report/search?pageNum=${pageNum || 0}&pageSize=${
    pageSize || 0
  }`
  return doPost(url, request)
}

export const downloadAuditSummaryIssueReportExcel = (request) => {
  const url = `${API_ROOT}/files/download/project-audit-report-issue`
  return doPostDownload(url, request)
}
